<template>
  <v-container fluid>
    <v-card tile>
      <div class="pl-6">
        <p class="text-body-1 font-weight-regular pt-4">
          Total precalificaciones completadas:
          {{ totalRegistros }}
        </p>
        <p class="text-caption text--secondary font-weight-bold mt-n3 pb-4" v-if="selectedFecha && selectedFecha[0]">
          <v-icon class="" color="black">mdi-calendar-range</v-icon>
          del {{ selectedFecha[0] }} al {{ selectedFecha[1] }}
        </p>
        <p class="text-caption text--secondary font-weight-bold mt-n3 pb-4" v-else>

        </p>
      </div>
    </v-card>

    <v-row>
      <!-- Recuadro para la tabla -->
      <v-col cols="10">
        <v-data-table disable-pagination :options.sync="options" :hide-default-footer="true" :headers="headers"
          :items="datosTabla" item-key="id" class="elevation-2" @click:row="handleClick">
          <!-- /**exportar registros a documento de excel */ -->
          <template v-slot:top>
            <v-row no-gutters>
              <v-spacer>
              </v-spacer>
              <v-btn :loading="generando" :disabled="generando" x-small @click="exportToExcel" class="mt-3 ml-1 mr-1 flo" color="success">
                Exportar a Excel
              </v-btn>
            </v-row>
          </template>
          <!-- /**exportar registros a documento de excel, fin */ -->
          <template v-slot:[`item.resultado_evaluacion`]="{ item }">
            <v-chip v-if="item.resultado_evaluacion == 'rechazado'"
              :color="item.resultado_evaluacion == 'rechazado' ? 'red' : ''" dark>
              ROJO
            </v-chip>
            <v-chip v-if="item.resultado_evaluacion == 'revisión'"
              :color="item.resultado_evaluacion == 'revisión' ? 'yellow accent-2' : ''">
              AMARILLO
            </v-chip>
            <v-chip v-if="item.resultado_evaluacion == 'aprobado'"
              :color="item.resultado_evaluacion == 'aprobado' ? 'green' : ''" dark>
              VERDE
            </v-chip>
          </template>
          <template v-slot:[`item.contado`]="{ item }">
            <span> {{ formatCellValue(item.contado, 'boolean') }}</span>
          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ fnGetDateTime(item.createdAt) }}
          </template>
          <template v-slot:[`item.fecha_de_nacimiento`]="{ item }">
            {{ fnGetDateUTC(item.fecha_de_nacimiento) }}
          </template>
          <template v-slot:[`item.flag_precalificacion_completada_fecha`]="{ item }">
            {{ fnGetDateTime(item.flag_precalificacion_completada_fecha) }}
          </template>
          <template v-slot:[`item.fecha_campania`]="{ item }">
            {{ fnGetDateUTC(item.fecha_campania) }}
          </template>
          <!-- verificamos si tiene un fiador -->
          <template v-slot:[`item.fiador_nombre_completo`]="{ item }">
            <span v-if="!item.fiador_nombre_completo">-</span>
            <span v-if="item.fiador_nombre_completo">{{ item.fiador_nombre_completo }}</span>
          </template>

          <!-- para el botón de VER -->
          <template v-slot:[`item.ver`]="{ item }">
            <v-btn x-small dark color="#031D6A" @click="fnVerRegistro(item)">VER</v-btn>
          </template>
        </v-data-table>
        <!-- PAGINACION -->
        <v-col cols="12">
          <v-col offset="9" cols="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Registros por página"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col class="">
            Total de registros: {{ totalRegistros }}
            <v-pagination class="float-right" v-model="page" :length="totalPages" total-visible="15"
              next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
          </v-col>
        </v-col>
        <!-- FIN PAGINACION -->
      </v-col>

      <!-- recuadro para los parámetros de búsqueda -->
      <v-col cols="2">
        <v-card tile>
          <div class="pt-2">
            <p class="text-body-2 font-weight-medium text--secondary pl-4">
              Parámetros de búsqueda
            </p>

            <v-card-text class="mt-n6">

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar" v-model="id"
                label="ID / No. de gestión" prepend-icon="mdi-database-search" dense></v-text-field>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar" v-model="nombre"
                label="Deudor" prepend-icon="mdi-database-search" class="" dense></v-text-field>

              <v-menu ref="fechaDeNacimientoDialog" v-model="modalFechaDeNacimiento" :close-on-content-click="false"
                :nudge-right="-17" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                    v-model="SelectedFechasDeNacimiento" label="Fecha de nacimiento" prepend-icon="mdi-calendar"
                    readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240"
                  no-title scrollable v-model="dialogVarSelectedFechasDeNacimiento" range :max="disabledFecha"
                  color="primary" header-color="primary">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalFechaDeNacimiento = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="primary"
                    @click="$refs.fechaDeNacimientoDialog.save(dialogVarSelectedFechasDeNacimiento)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="search_nit" label="NIT" prepend-icon="mdi-database-search" dense></v-text-field>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="documentoIdentificacion" label="Documento identificación" prepend-icon="mdi-database-search"
                dense></v-text-field>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="nombre_fiador" label="Fiador" prepend-icon="mdi-database-search" class="" dense></v-text-field>

              <v-select @change="fnAplicarParametros" clearable hint="Enter para filtrar"
                v-model="resultadoEvaluacion" :items="itemsResultadoEvaluacion" label="Resultado evaluación"
                prepend-icon="mdi-database-search" dense></v-select>

              <v-menu ref="fechaDialog" v-model="modalFechas" :close-on-content-click="false" :nudge-right="-17"
                transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                    v-model="selectedFecha" label="Fecha de sincronización" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>
                <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240"
                  no-title scrollable v-model="dialogVarSelectedFecha" range :max="disabledFecha" color="primary"
                  header-color="primary">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalFechas = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.fechaDialog.save(dialogVarSelectedFecha)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-menu ref="fechaCompletacionDialog" v-model="modalFechaCmpletacion" :close-on-content-click="false"
                :nudge-right="-17" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                    v-model="SelectedFechasCompletacion" label="Complementos cargados" prepend-icon="mdi-calendar"
                    readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240"
                  no-title scrollable v-model="dialogVarSelectedFechasCompletacion" range :max="disabledFecha"
                  color="primary" header-color="primary">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalFechaCmpletacion = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="primary"
                    @click="$refs.fechaCompletacionDialog.save(dialogVarSelectedFechasCompletacion)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-menu ref="fechaCampaniasDialog" v-model="modalFechaCampania" :close-on-content-click="false"
                :nudge-right="-17" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                    v-model="SelectedFechasCampania" label="Fecha de evaluación" prepend-icon="mdi-calendar" readonly
                    v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240"
                  no-title scrollable v-model="dialogVarSelectedFechasCampania" range :max="disabledFecha"
                  color="primary" header-color="primary">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalFechaCampania = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.fechaCampaniasDialog.save(dialogVarSelectedFechasCampania)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"  v-model="campania" label="Campaña" prepend-icon="mdi-database-search"
              dense></v-text-field>


              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="usuarios" label="Agente de comercio" prepend-icon="mdi-database-search" dense></v-text-field>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar" v-model="sector"
                label="Sector" prepend-icon="mdi-database-search" dense></v-text-field>


              <v-select @change="fnAplicarParametros" clearable hint="Enter para filtrar"
                v-model="search_contado" :items="itemsContado" label="Contado" prepend-icon="mdi-database-search"
                dense></v-select>

               


            </v-card-text>
          </div>
          <v-card-actions class="justify-end pb-6 mt-n4">
            <v-btn small color="#031D6A" class="white--text mr-1" @click="fnAplicarParametros()">
              APLICAR PARÁMETROS
              <v-icon small class="ml-2">mdi-magnify</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogIniciarProceso" max-width="1100" persistent>
      <v-card elevation="0">
        <v-card-title class="text-body-1">Iniciar proceso</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p class="text-h6 text--primary font-weight-regular mt-1">
            Evaluación #{{ detalleEvaluacion.id }}
          </p>
          <p class="text-body-2 text--secondary font-weight-regular mt-n3">
            <v-icon class="" color="gray">mdi-calendar-range</v-icon>
            Fecha evaluación: {{ fnGetDate(detalleEvaluacion.createdAt) }}
          </p>

          <v-card class="mt-n2">
            <div class="text-center">
              <v-avatar size="56" color="#031D6A" class="my-3">
                <v-icon dark size="46"> mdi-account </v-icon>
              </v-avatar>
              <p class="text-h6 text--primary font-weight-regular mt-n2">
                {{ detalleEvaluacion.primer_nombre }}
                {{ detalleEvaluacion.segundo_nombre }}
                {{ detalleEvaluacion.primer_apellido }}
                {{ detalleEvaluacion.segundo_apellido }}
                {{ detalleEvaluacion.tercer_apellido_o_casada }}
              </p>
            </div>

            <v-row class="mx-4">
              <v-col cols="6" md="6" class="pr-8">
                <table>
                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Número de documento identifiación
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.dpi }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Identificación extendida en
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{
                        detalleEvaluacion.identificacion_extendida_en_departamento
                      }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Primer nombre
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.primer_nombre }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Segundo nombre
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      <!-- mostramos un guión mayor si no contiene el campo, si es una cadena vacía  -->
                      <span v-if="detalleEvaluacion.segundo_nombre">{{
                        detalleEvaluacion.segundo_nombre
                      }}</span>
                      <span v-if="!detalleEvaluacion.segundo_nombre">-</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Tercer nombre
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      <span v-if="detalleEvaluacion.tercer_nombre">{{
                        detalleEvaluacion.tercer_nombre
                      }}</span>
                      <span v-if="!detalleEvaluacion.tercer_nombre">-</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Primer apellido
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.primer_apellido }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Segundo apellido
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.segundo_apellido }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Tercer apellido
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      <span v-if="detalleEvaluacion.tercer_apellido_o_casada">{{
                        detalleEvaluacion.tercer_apellido_o_casada
                      }}</span>
                      <span v-if="!detalleEvaluacion.tercer_apellido_o_casada">-</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Fecha nacimiento
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ fnGetDateUTC(detalleEvaluacion.fecha_de_nacimiento) }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Dirección de la consejera
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.consejera_direccion }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Dirección entrega
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.entrega_direccion }}
                    </td>
                  </tr>
                </table>
              </v-col>

              <!-- parte derecha de la tabla con la info de la evaluación -->
              <v-col cols="6" md="6" class="pl-8">
                <table>
                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Tipo de vivienda
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.vivienda_tipo }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">Ubicación</td>
                    <td class="text--secondary font-weight-regular" align="right">
                      <span v-if="detalleEvaluacion.vivienda_ubicacion">
                        {{ JSON.parse(detalleEvaluacion.vivienda_ubicacion).direccion }}
                      </span>
                      <span v-else>---</span>
                    </td>
                    
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Número de celular
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                        <span v-if="detalleEvaluacion.numero_de_celular ">{{ detalleEvaluacion.numero_de_celular }}</span>
                      <span v-else>---</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Teléfono de casa
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.telefono_de_casa }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Dirección de trabajo
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      <span v-if="detalleEvaluacion.trabajo_direccion ">{{ detalleEvaluacion.trabajo_direccion }}</span>
                      <span v-else>---</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Teléfono de trabajo
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      <span v-if="detalleEvaluacion.trabajo_telefono ">{{ detalleEvaluacion.trabajo_telefono }}</span>
                      <span v-else>---</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">NIT</td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.nit }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">Sector</td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.sector }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">Ruta</td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.ruta }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Fecha de evaluación
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ fnGetDateUTC(detalleEvaluacion.fecha_campania) }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Campaña
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.campania }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Asignación automatica de campaña
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      {{ detalleEvaluacion.campania_consulta_mensaje
                          ?.replace(/^AUTO CAMPAÑA:\s*/, '')
                          .replace(/\bASIGNADA\b/, '') }}
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">
                      Código referencia
                    </td>
                    <td class="text--secondary font-weight-regular" align="right">
                      <span v-if="detalleEvaluacion.codigo_referencia ">{{ detalleEvaluacion.codigo_referencia }}</span>
                      <span v-else>---</span>
                    </td>
                  </tr>

                  <tr>
                    <td class="text--secondary font-weight-bold">Contado</td>
                    <td class="text--secondary font-weight-regular" align="right">
                      <span v-if="detalleEvaluacion.contado ">{{ detalleEvaluacion.contado }}</span>
                      <span v-else>---</span>
                    </td>
                  </tr>
                </table>
                <small class="red--text" v-if="disableSiguienteCampania">{{ siguienteCampaniaStatus }}</small>
              </v-col>

            </v-row>
          </v-card>
        </v-card-text>

        <v-card-actions class="justify-end pb-4">

          <v-btn :disabled="bloquearonSync || bloqueoInicioDeGestion" color="#031D6A" class="px-5 white--text mr-4" @click="fnIniciarGestion()">
            INICIAR GESTIÓN
            <v-icon class="ml-2">mdi-check</v-icon>
          </v-btn>
          <v-progress-circular v-if="bloquearonSync" class="mr-2" title="Estableciendo conexión con el servidor en Guatemala"
            indeterminate color="primary"></v-progress-circular>
          <v-btn :disabled="disableSiguienteCampania || bloquearonSync || bloqueoAsignacionSiguienteCampania" color="orange" outlined hint="siguiente campaña"
            show-hint="siguiente campaña" class="px-5 ml-4 mr-2" @click="fnSiguienteCampania()">SIGUIENTE
            CAMPAÑA</v-btn>

          <v-btn :disabled="bloquearonSync" text class="mr-1"
            @click="dialogIniciarProceso = false, disableSiguienteCampania = false, siguienteCampaniaStatus = null">
            CERRAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3500" color="success" right top class="mt-14">
      <v-row>
        <v-col cols="1" md="1">
          <v-icon>mdi-check-circle</v-icon>
        </v-col>
        <v-col cols="11" md="11">
          <div class="text-center">
            <p class="text-subtitle-2 font-weight-medium white--text">
              Se inicio correctamente la gestión
            </p>
            <p class="text-subtitle-2 font-weight-medium white--text mt-n4 mb-n1">
              para la evaluación #{{ detalleEvaluacion.id }}
            </p>
          </div>
        </v-col>
      </v-row>
      <!-- /**LOADING BAR */ -->
      <v-progress-linear v-model="loadingValue" :buffer-value="bufferValue" color="white" absolute bottom rounded />
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import moment from 'moment';
require('moment/locale/es.js');

export default {
  name: 'PrecalificacionesCompletadas',
  data() {
    return {
      generando: false,
      campania: null,
      bloquearonSync: false,
      disableSiguienteCampania: false,
      siguienteCampaniaStatus: null,
      //loading
      loadingValue: 0,
      bufferValue: 0,
      interval: 0,
      //paginacion
      options: {},
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [10, 25, 50, 100],
      totalRegistros: 0,
      //paginacion fin
      snackbar: false,
      dialogIniciarProceso: false, //para mostrar la ventana de dialogo que contiene los detalles de la evaluacion

      fechaSelect: '', // fecha de prueba que se muestra en la card superior

      //encabezados para la tabla
      headers: [
        {
          text: 'Número evaluación',
          align: 'start',
          value: 'id',
          sortable: true,
          width: 80
        },
        {
          text: 'Nombre persona',
          align: 'start',
          value: 'deudor_nombre_completo',
          sortable: false,
          width: 180,
        },
        {
          text: 'Fecha de nacimiento',
          align: 'start',
          value: 'fecha_de_nacimiento',
          sortable: false,
          width: 150,
          type: 'date'
        },
        {
          text: 'NIT',
          align: 'start',
          value: 'nit',
          sortable: false,
        },
        {
          text: 'Documento identificación',
          align: 'start',
          value: 'dpi',
          sortable: false,
        },
        {
          text: 'Fiador',
          align: 'center',
          value: 'fiador_nombre_completo',
          sortable: false,
        },
        {
          text: 'Resultado evaluación',
          align: 'start',
          value: 'resultado_evaluacion',
          sortable: false,
        },
        {
          text: 'Fecha de sincronización',
          align: 'start',
          value: 'createdAt',
          sortable: false,
          type: 'datetime',
          width: 180

        },
        {
          text: 'Complementos cargados',
          align: 'start',
          value: 'flag_precalificacion_completada_fecha',
          sortable: false,
          width: 180,
          type: 'datetime'
        },
        {
          text: 'Fecha de evaluación',
          align: 'start',
          value: 'fecha_campania',
          sortable: false,
          width: 180,
          type: 'dateUTC'
        },
        {
          text: 'Fecha campaña',
          align: 'center',
          value: 'campania',
          sortable: false,
          width: 150
        },
        {
          text: 'Código de usuario',
          align: 'start',
          value: 'CREADO_POR_USUARIO',
          sortable: false,
          type: 'string',
          width: 150
        },
        {
          text: 'Nombre de usuario',
          align: 'start',
          value: 'CREADO_POR_USUARIO_NOMBRE',
          width: 180,
          sortable: false,
          type: 'string'
        },
        { text: 'Sector', align: 'start', value: 'sector', sortable: false },
        { text: 'Contado', align: 'center', value: 'contado', sortable: false, type: 'boolean' },
        { text: 'Ver', align: 'center', value: 'ver', sortable: false },
      ],

      //datos para mostrar en la tabla (se tiene un dato de prueba)
      datosTabla: [],

      //--------------variables para el cuadro de búsqueda

      //variables para la fecha
      modalFechas: false,
      dialogVarSelectedFecha: null,
      selectedFecha: [
        null,
        null
      ], //en esta variable es donde se almacenará la fecha o el rango de fechas
      disabledFecha: moment().format('YYYY-MM-DD'),

      modalFechaDeNacimiento: false,
      dialogVarSelectedFechasDeNacimiento: null,
      SelectedFechasDeNacimiento: [
        null,
        null
      ], //en esta variable es donde se almacenará la fecha o el rango de fechas

      modalFechaCmpletacion: false,
      dialogVarSelectedFechasCompletacion: null,
      SelectedFechasCompletacion: [
        null,
        null
      ], //en esta variable es donde se almacenará la fecha o el rango de fechas

      modalFechaCampania: false,
      dialogVarSelectedFechasCampania: null,
      SelectedFechasCampania: [
        null,
        null
      ], //en esta variable es donde se almacenará la fecha o el rango de fechas


      nombre: null, //almacenamos el nombre para los parámetros de búsqueda
      nombre_fiador: null,
      search_nit: null,
      search_contado: null,
      documentoIdentificacion: null,
      perfilPersona: null,
      resultadoEvaluacion: null,
      usuarios: null,
      sector: null,
      ruta: null,
      id: null,
      sap: null,
      //Valores con valores temporales
      itemsPerfilPersona: ['Deudor', 'Fiador', 'Todos'],
      itemsResultadoEvaluacion: ['VERDE', 'AMARILLO', 'ROJO'],
      itemsContado: ['Si', 'No'],
      itemsUsuarios: ['dtk'],
      itemsSector: ['95', '56'],
      itemsRuta: ['EMP85A01', 'EMP85A02'],

      detalleEvaluacion: {}, //para mostrar la info en la ventana de dialogo
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    /**usar las filas de la columna, para hacer click en gestion */
    handleClick(value) {
      this.fnVerRegistro(value)
    },
    /**
     * *
     * exportar registros a documento de excel*/
    async exportToExcel() {
      this.generando = true;
      try {
        let XLSX = require('xlsx');
        // Obtener todos los registros
        const allRecords = await this.getAllRecords();

        // Preparar los datos para el Excel
        const excelData = allRecords.map((record) => {
          let rowData = {};
          this.headers.forEach((header) => {
            if (header.text != 'Ver') {
              // Usar el 'text' como nombre de columna y 'value' para obtener el dato
              rowData[header.text] = this.formatCellValue(
                record[header.value],
                header.type
              );
            }
          });
          return rowData;
        });

        // Crear una hoja de trabajo
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Crear un libro de trabajo y agregar la hoja
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Registros');

        // Guardar el archivo
        XLSX.writeFile(wb, 'precalificaciones completradas.xlsx');
          this.generando = false;
      } catch (error) {
        console.error('Error al exportar a Excel:', error);
        this.$notify({
          title: 'Error',
          text: error,
          color: '#D32F2F',
          timeout: 5000,
        });
        this.generando = false;
        // Aquí puedes agregar un manejo de errores más robusto, como mostrar un mensaje al usuario
      }
    },
    async getAllRecords() {
      const totalRecords = this.totalRegistros;
      const params = this.getParams();
      params['$limit'] = totalRecords;
      params['$skip'] = 0;

      try {
        const response = await this.findGestiones({ query: params });
        console.log('todas las gestiones: ', response);
        return response.data;
      } catch (error) {
        console.error('Error al obtener todos los registros:', error);
        throw error;
      }
    },
    formatCellValue(value, type) {
      if (type === 'deudor') {
        return 'deudor';
      }
      if (type === 'datetimeUTC') {
        return this.fnGetDateUTCTime(value);
      }
      if (type === 'dateUTC') {
        return this.fnGetDateUTC(value);
      }
      if (type === 'date') {
        return this.fnGetDate(value);
      }
      if (type === 'datetime') {
        return this.fnGetDateTime(value);
      }
      if (type === 'boolean') {
        if (value == 1) {
          return 'Si'
        }
        else if (value == 0) {
          return 'No'
        } else {
          return '-'
        }
      }
      // Manejar otros tipos según sea necesario
      return value;
    },
    /**
     * *
     * exportar registros a documento de excel, fin*/
    //
    fnGetDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : '';
    },
    fnGetDateTime(date) {
      return date ? moment(date).format('DD-MM-YYYY HH:mm:ss a') : '';
    },
    fnGetDateUTC(date) {
      return date ? moment(date).utc().format('DD-MM-YYYY') : '';
    },
    //loading
    startBuffer() {
      clearInterval(this.interval);

      this.interval = setInterval(() => {
        this.loadingValue += Math.random() * (15 - 5) + 5;
        this.bufferValue += Math.random() * (15 - 5) + 6;
      }, 320);
    },
    //
    ...mapActions('Gestiones', {
      findGestiones: 'find',
      getGestiones: 'get',
      patchGestiones: 'patch',
    }),
    ...mapActions('CheckNextCampania', {
      findCheckNextCampania: 'find'
    }),
    getParams() {
      const params = {};
      /**paginacion */
      params['$limit'] = this.pageSize;
      params['$skip'] = (this.page - 1) * this.pageSize;

      if (
        this.options.sortBy &&
        this.options.sortBy.length === 1 &&
        this.options.sortDesc.length === 1
      ) {
        let sorting = {};
        let flag = this.options.sortDesc[0] ? -1 : 1;
        sorting[this.options.sortBy[0].toString()] = flag;

        console.log('sorting', sorting);
        params['$sort'] = sorting;
      } else {
        params['$sort'] = { id: -1 };
      }
      /**paginacion fin */

      params['flag_precalificacion_completada'] = 1;
      params['flag_precalificacion_eliminada'] = { $eq: null };
      params['flag_precalificacion_en_revision'] = { $eq: null };
      /** parametros de búsqueda */
      /**fechas */
      /** */
      if (this.selectedFecha && this.selectedFecha[0] && this.selectedFecha[1]) {
        /**fechas */
        /** */
        let split1 = this.selectedFecha[0].split('-');
        let split2 = this.selectedFecha[1].split('-');
        var firstDay = new Date(split1[2], split1[1] - 1, split1[0], 0, 0, 0);
        var lastDay = new Date(split2[2], split2[1] - 1, split2[0], 23, 59, 59);
        params['createdAt'] = {
          $gte: firstDay,
          $lte: lastDay,
        };
      }

      /** */
      if (this.SelectedFechasDeNacimiento != null) {
        if (this.SelectedFechasDeNacimiento[0] && this.SelectedFechasDeNacimiento[1]) {
          /**fechas */
          /** */
          let split1 = this.SelectedFechasDeNacimiento[0].split('-');
          let split2 = this.SelectedFechasDeNacimiento[1].split('-');
          let firstDay = new Date(split1[2], split1[1] - 1, split1[0] - 2, 23, 59, 59);
          let lastDay = new Date(split2[2], split2[1] - 1, split2[0] - 1, 23, 59, 59);
          params['fecha_de_nacimiento'] = {
            $gte: firstDay,
            $lte: lastDay,
          };
        }
      }
      /** */
      if (this.SelectedFechasCompletacion != null) {
        if (this.SelectedFechasCompletacion[0] && this.SelectedFechasCompletacion[1]) {
          /**fechas */
          /** */
          let split1 = this.SelectedFechasCompletacion[0].split('-');
          let split2 = this.SelectedFechasCompletacion[1].split('-');
          let firstDay = new Date(split1[2], split1[1] - 1, split1[0], 0, 0, 0);
          let lastDay = new Date(split2[2], split2[1] - 1, split2[0], 23, 59, 59);
          params['flag_precalificacion_completada_fecha'] = {
            $gte: firstDay,
            $lte: lastDay,
          };
        }
      }
      /** */
      if (this.SelectedFechasCampania != null) {
        if (this.SelectedFechasCampania[0] && this.SelectedFechasCampania[1]) {
          /**fechas */
          /** */
          let split1 = this.SelectedFechasCampania[0].split('-');
          let split2 = this.SelectedFechasCampania[1].split('-');
          let firstDay = new Date(split1[2], split1[1] - 1, split1[0] - 2, 23, 59, 59);
          let lastDay = new Date(split2[2], split2[1] - 1, split2[0] - 1, 23, 59, 59);
          params['fecha_campania'] = {
            $gte: firstDay,
            $lte: lastDay,
          };
        }
      }
      /** */
      /**fechas */
      /** */
      if (this.nombre) {
        const nombres = this.nombre.split(' ').filter(Boolean); // Separa el término de búsqueda en palabras individuales
        const conditions = nombres.map(nombrePart => {
          return [
            { deudor_nombre_completo: { $like: `%${nombrePart}%` } },
            { primer_nombre: { $like: `%${nombrePart}%` } },
            { segundo_nombre: { $like: `%${nombrePart}%` } },
            { tercer_nombre: { $like: `%${nombrePart}%` } },
            { primer_apellido: { $like: `%${nombrePart}%` } },
            { segundo_apellido: { $like: `%${nombrePart}%` } },
            { tercer_apellido_o_casada: { $like: `%${nombrePart}%` } }
          ];
        });

        // Combina las condiciones de cada palabra en un solo array
        params['$and'] = conditions.map(condGroup => ({ $or: condGroup }));
      }

      if (this.nombre_fiador) {
        const nombresFiador = this.nombre_fiador.split(' ').filter(Boolean); // Divide el término de búsqueda en palabras individuales
        const conditionsFiador = nombresFiador.map(nombrePart => {
          return [
            { fiador_nombre_completo: { $like: `%${nombrePart}%` } },
            { fiador_primer_nombre: { $like: `%${nombrePart}%` } },
            { fiador_segundo_nombre: { $like: `%${nombrePart}%` } },
            { fiador_tercer_nombre: { $like: `%${nombrePart}%` } },
            { fiador_primer_apellido: { $like: `%${nombrePart}%` } },
            { fiador_segundo_apellido: { $like: `%${nombrePart}%` } },
            { fiador_tercer_apellido: { $like: `%${nombrePart}%` } }
          ];
        });

        // Combina las condiciones de cada palabra en un solo array
        params['$and'] = conditionsFiador.map(condGroup => ({ $or: condGroup }));
      }

      /** */
      if (this.documentoIdentificacion) {
        params['dpi'] = {
          $like: '%' + this.documentoIdentificacion + '%',
        };
      }
      /** */
      if (this.documentoIdentificacion) {
        params['dpi'] = {
          $like: '%' + this.documentoIdentificacion + '%',
        };
      }
      /** */
      if (this.resultadoEvaluacion) {
        if (this.resultadoEvaluacion == 'ROJO') {
          params['resultado_evaluacion'] = 'rechazado';
        }
        if (this.resultadoEvaluacion == 'AMARILLO') {
          params['resultado_evaluacion'] = 'revisión';
        }
        if (this.resultadoEvaluacion == 'VERDE') {
          params['resultado_evaluacion'] = 'aprobado';
        }
      }
      /** */
      if (this.sector) {
        params['sector'] = this.sector;
      }
      if (this.search_nit) {
        params['nit'] = this.search_nit;
      }
      if (this.campania) {
        params['campania'] = this.campania;
      }
      /** */
      if (this.ruta) {
        params['ruta'] = this.ruta;
      }
      if (this.id) {
        params['id'] = this.id
      }
      if (this.sap) {
        params['codigo_sap'] = this.sap
      }
      if (this.usuarios) {
        params['CREADO_POR_USUARIO'] = {
          $like: '%' + this.usuarios + '%',
        };
      }

      if (this.search_contado) {
        if (this.search_contado == 'Si') {
          params['contado'] = true
        } else {
          params['contado'] = null
        }

      }
      /** parametros de búsqueda, fin */
      return params;
    },
    main() {
      this.findGestiones({ query: this.getParams() }).then((r) => {
        for (let index = 0; index < r.data.length; index++) {
          /**dar formato al campo "fullName", desplieigue en tabla */
          const element = r.data[index];

          let fullName = [
            element.primer_nombre,
            element.segundo_nombre,
            element.tercer_nombre,
            element.primer_apellido,
            element.segundo_apellido,
            element.tercer_apellido_o_casada,
          ]
            .filter(Boolean)
            .join(' ');

          r.data[index].nombre_completo = fullName;
        }
        /**dar formato al campo "fullName", desplieigue en tabla */
        /** */
        this.datosTabla = r.data;
        this.total_precalificaciones = r.total;
        /** */
        this.totalRegistros = r.total;
        this.totalPages = Math.ceil(
          parseInt(r.total) / parseInt(this.pageSize)
        );
      }).catch(e => {
        this.$notify({
          title: 'Error',
          text: e,
          color: '#D32F2F',
          timeout: 5000,
        });

      });
    },
    /**paginacion */
    handlePageChange(value) {
      this.page = value;
      this.main();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.main();
    },
    /**paginacion fin */
    fnVerRegistro(data) {
      console.log(data);
      this.detalleEvaluacion = Object.assign(data);

      this.dialogIniciarProceso = true;
    },

    //funcion para recopilar toda la información cuando se da clic en el botón de aplicar parámetros (en la card de búsqueda)
    fnAplicarParametros() {
      console.log('aplicanco parámetros de búsqueda');
      this.page = 1;

      const parametros = {
        dias: this.selectedFecha,
        nombre: this.nombre,
        documentoId: this.documentoIdentificacion,
        perfilP: this.perfilPersona,
        resultadoE: this.resultadoEvaluacion,
        usuarios: this.usuarios,
        sector: this.sector,
        ruta: this.ruta,
      };
      console.log(parametros);

      this.main();
    },

    async fnVerificarIfAplicanteYaTieneProcesoAbierto(gestionToVerify) {
      const gestion = await this.findGestiones({
        query: {
          dpi: gestionToVerify.dpi,
          estado: {
            $in: ['En revisión', 'Con Pendientes', 'Con rectificación', 'Con rectificación y pendientes', 'Con compromiso de pago', 'Lista para aprobación', 'Lista para aprobación con compromiso de pago"']
          }
        }
      })

      if (gestion.total >= 1) {
        return {
          resultado: false,
          gestion2: gestion,
          gestion: `Prospecto ${gestionToVerify.dpi} ya tiene gestión No. ${gestion.data[0].id} con estado ${gestion.data[0].estado}`
        }
      } else {
        return {
          resultado: true
        }
      }


    },
    //función para cuando se da clic en el botón de INICIAR GESTIÓN
    async fnIniciarGestion() {
      console.log('iniciando gestión');
      this.bloquearonSync = true;

      const verifyBeforeStart = await this.fnVerificarIfAplicanteYaTieneProcesoAbierto(this.detalleEvaluacion);

      if (verifyBeforeStart.resultado == false) {

        this.$notify({
          title: 'Error',
          text: `${JSON.stringify(verifyBeforeStart.gestion)}`,
          color: '#FF6F00',
          timeout: 5000,
        });

        this.bloquearonSync = false;
        return null;
      }


      await this.patchGestiones([
        this.detalleEvaluacion.id,
        {
          inicio_de_gestion_web_user_id: this.currentUser.id,
          inicio_de_gestion_web: this.currentUser.nombre,
          inicio_de_gestion_web_user_codigo: this.currentUser.usuario,
          flag_precalificacion_en_revision: 1,
          flag_precalificacion_en_revision_fecha: moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSSS+00:00'),
        },
      ]).then((r) => {
        console.log(r);
        this.detalleEvaluacion = r;
        //this.startBuffer();
        this.dialogIniciarProceso = false; //cerramos la ventana de dialogo
        this.snackbar = true; //mostramos mensaje exitoso
        this.main();

        let vm = this;
        setTimeout(() => {
          vm.bloquearonSync = false;
          vm.$router.push(`/detalle-gestion/${r.id}`);
        }, 500);
      }).catch(e => {
        console.log(e);
        this.$notify({
          title: 'Error',
          text: e,
          color: '#FF6F00',
          timeout: 5000,
        });
        this.dialogIniciarProceso = false;
        this.main();
        this.bloquearonSync = false;

      });
    },

    //función para cuando se da clic en el botón de SIGUIENTE CAMPAÑA
    async fnSiguienteCampania() {
      this.bloquearonSync = true;

      const params = {};
      params['sector'] = this.detalleEvaluacion.sector;
      params['fecha_campania'] = this.detalleEvaluacion.fecha_campania;
      try {
        const campaniaStatus = await axios
          .get(process.env.VUE_APP_FEATHERS_SERVER + 'check-next-campania', {
            params: params,
            headers: {
              'Content-Type': 'application/json',
              Authorization:
                'Bearer ' + window.localStorage.getItem('feathers-jwt'),
            },
          });

        const { currentCampaign, nextCampaign } = campaniaStatus.data;
        const gestionYaEnCampaniaVigente = currentCampaign.campania === this.detalleEvaluacion.campania;

        // Si la gestión está atrasada respecto a la campaña vigente de hoy, hay que
        // ponerla al día con esa campaña vigente antes de mirar más adelante.
        let campaniaDestino = null;
        let mensajeDestino = null;

        if (!gestionYaEnCampaniaVigente) {
          campaniaDestino = currentCampaign;
          mensajeDestino = 'AUTO CAMPAÑA: CAMPAÑA EN CURSO ASIGNADA';
        } else if (nextCampaign) {
          campaniaDestino = nextCampaign;
          mensajeDestino = 'AUTO CAMPAÑA: SIGUIENTE CAMPAÑA EXISTENTE ASIGNADA';
        }

        if (!campaniaDestino) {
          // Ya está en la campaña vigente y no hay ninguna futura registrada: bloqueo real.
          this.disableSiguienteCampania = true;
          this.siguienteCampaniaStatus = `La ultima campaña asignada para el sector ${this.detalleEvaluacion.sector} es del ${currentCampaign.fecha_inicio} al ${currentCampaign.fecha_fin}`
          this.bloquearonSync = false;
          return;
        }

        const formattedDate = moment(campaniaDestino.fecha_inicio, "M/DD/YYYY").toISOString();

        this.patchGestiones([this.detalleEvaluacion.id, {
          campania: campaniaDestino.campania,
          fecha_campania: formattedDate,
          campania_consulta_mensaje: mensajeDestino,
        }]).then(() => {
          this.$notify({
            title: 'Nueva campaña',
            text: 'Se le ha asignado nueva campaña a la evaluación/gestión',
            color: '#4caf50',
            timeout: 3000,
          });

          this.fnIniciarGestion()
        })

      } catch (error) {
        this.bloquearonSync = false;
        console.log(error);

        this.$notify({
          title: 'Error al consultar información de siguiente campaña',
          text: `No se ha encontrado una siguiente campaña para el sector ${this.detalleEvaluacion.sector}`,
          color: '#D32F2F',
          timeout: 8000,
        });
      }
    },
  },

  watch: {
    options: {
      // eslint-disable-next-line no-unused-vars
      handler(newValue) {
        this.main();
      },
      deep: true,
      immediate: true,
    },
    //loading
    loadingValue(val) {
      if (val < 100) return;

      this.value = 0;
      this.bufferValue = 10;
      this.startBuffer();
    },
    /** parametrización por fechas con el calendario*/
    dialogVarSelectedFecha(newValue) {
      if (newValue != null) {
        this.selectedFecha = [
          moment(newValue[0]).format('DD-MM-YYYY'),
          moment(newValue[1]).format('DD-MM-YYYY'),
        ];
      } else {
        this.selectedFecha = [null, null
        ];
      }

    },

    dialogVarSelectedFechasDeNacimiento(newValue) {
      if (newValue != null) {
        this.SelectedFechasDeNacimiento = [
          moment(newValue[0]).format('DD-MM-YYYY'),
          moment(newValue[1]).format('DD-MM-YYYY'),
        ];
      } else {
        this.SelectedFechasDeNacimiento = [null, null
        ];
      }
    },

    dialogVarSelectedFechasCompletacion(newValue) {
      if (newValue != null) {
        this.SelectedFechasCompletacion = [
          moment(newValue[0]).format('DD-MM-YYYY'),
          moment(newValue[1]).format('DD-MM-YYYY'),
        ];
      } else {
        this.SelectedFechasCompletacion = [null, null
        ];
      }
    },

    dialogVarSelectedFechasCampania(newValue) {
      if (newValue != null) {
        this.SelectedFechasCampania = [
          moment(newValue[0]).format('DD-MM-YYYY'),
          moment(newValue[1]).format('DD-MM-YYYY'),
        ];
      } else {
        this.SelectedFechasCampania = [null, null
        ];
      }
    },
  },

  mounted() {
    this.main();
  },
  computed: {
    bloqueoInicioDeGestion(){
      if (this.detalleEvaluacion.campania_consulta_mensaje == 'AUTO CAMPAÑA: ULTIMA CAMPAÑA EXISTENTE ASIGNADA'){
        return true;
      } else {
        return false;
      }
    },
    bloqueoAsignacionSiguienteCampania(){
      if (this.detalleEvaluacion.campania_consulta_mensaje == 'AUTO CAMPAÑA: CAMPAÑA EN CURSO ASIGNADA' || this.detalleEvaluacion.campania_consulta_mensaje == 'AUTO CAMPAÑA: SIGUIENTE CAMPAÑA EXISTENTE ASIGNADA'){
        return true;
      } else {
        return false;
      }
    },
    currentUser() {
      return this.$store.state.auth.payload.usuario;
    },
  }
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 2px;
}
</style>
